export default "__VITE_ASSET__DwJatcx9__"